import { Routes } from '@angular/router';
import { LayoutComponent } from './features/layout/layout.component';
import { HomeComponent } from '../app/static-pages/home/home.component';
import { PageNotFoundComponent } from './static-pages/page-not-found/page-not-found.component';

export const routes: Routes = [
    { path:'', component: HomeComponent},
    { path: 'create-account/:id', loadComponent:()=> import('../app/static-pages/home/home.component').then(m => m.HomeComponent) },
    { path: 'create-account', loadComponent:()=> import('../app/static-pages/home/home.component').then(m => m.HomeComponent) },
    { path: '', component: LayoutComponent, loadChildren:()=> import('./features/features.module').then(m => m.featureRouteModule)},
    { path: '', loadChildren:()=> import('./static-pages/static.module').then(m => m.StaticRouteModule) },
    { path: '**', component: PageNotFoundComponent },
];
